import React from 'react';
import { Helmet } from "react-helmet-async";
import Header from './header/Header';
import ProductPresentation from './product-presentation/ProductPresentation';
import MyGoals from './mygoals/MyGoals';
import CallToAction from './calltoaction/CallToAction';
import NewsHome from './newshome/NewsHome';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>
          Cycle Solutions – effektiv avfallshantering med 60 års erfarenhet
        </title>
        <meta
          name="description"
          content="Upptäck vårt breda utbud av komprimatorer och balpressar, från Sveriges ledande tillverkare med över 60 års erfarenhet. Perfekt för effektiv avfallshantering."
        />
        <link
          rel="canonical"
          href="https://cyclesolutions.se/"
        />
      </Helmet>

      <div className='homepage'>
        <Header />
        <ProductPresentation />
        <MyGoals />
        <CallToAction />
        <NewsHome />
      </div>
    </>
  );
}

export default Home;
